var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#FCEDE8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 46.4141V26.6641C12 25.0391 12.9375 23.5391 14.5 22.9141L31.25 16.2266C31.6875 16.0391 32.25 16.0391 32.6875 16.2266L49.4375 22.9141C51 23.5391 52 25.0391 52 26.6641V46.4141C52 47.2891 51.3125 47.9141 50.5 47.9141H47.5C46.625 47.9141 46 47.2891 46 46.4141V29.9141C46 28.8516 45.0625 27.9141 44 27.9141H20C18.875 27.9141 18 28.8516 18 29.9141V46.4141C18 47.2891 17.3125 47.9141 16.5 47.9141H13.5C12.625 47.9141 12 47.2891 12 46.4141ZM35.5 39.9141H42.5C43.3125 39.9141 44 40.6016 44 41.4141V46.4141C44 47.2891 43.3125 47.9141 42.5 47.9141H35.5C34.625 47.9141 34 47.2891 34 46.4141V41.4141C34 40.6016 34.625 39.9141 35.5 39.9141ZM20 31.4141C20 30.6016 20.625 29.9141 21.5 29.9141H30.5C31.3125 29.9141 32 30.6016 32 31.4141V36.4141C32 37.2891 31.3125 37.9141 30.5 37.9141H21.5C20.625 37.9141 20 37.2891 20 36.4141V31.4141ZM21.5 39.9141H30.5C31.3125 39.9141 32 40.6016 32 41.4141V46.4141C32 47.2891 31.3125 47.9141 30.5 47.9141H21.5C20.625 47.9141 20 47.2891 20 46.4141V41.4141C20 40.6016 20.625 39.9141 21.5 39.9141Z",
    fill: "#E66E2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.65f2594edb8e361515ebd36b7effc856.svg";
export { ForwardRef as ReactComponent };